<template>
  <div>
    <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false" :model="form">
      <a-form-model-item label="催单用户">
        <a-input v-model="form.customer" disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="用户联系方式">
        <a-input v-model="form.telephone" disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="IFS 单号">
        <a-input v-model="form.ifsNo" disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="客户名称">
        <a-input v-model="form.customerName" disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="运输方式">
        <a-input v-model="form.expressCode" disabled="true"></a-input>
      </a-form-model-item>
      <a-form-model-item label="处理结果">
<!--        <div style="overflow: hidden;overflow-x:auto;white-space: nowrap;">-->
<!--          <a-space>-->
<!--            <a-button type="primary" shape="circle">催件人员已催件</a-button>-->
<!--            <a-button shape="round">催件人员已催件</a-button>-->
<!--            <a-button shape="round">催件人员已催件</a-button>-->
<!--            <a-button shape="round">催件人员已催件</a-button>-->
<!--          </a-space>-->
<!--        </div>-->
        <a-textarea v-model="form.dealResult" placeholder="默认为已处理" :rows="4" />
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import {changeStatus, getServiceTask} from "../../../api/serviceTaskApi";
async function save(){
  if (this.form.dealResult === null || this.form.dealResult === ''){
    this.form.dealResult = '已处理订单';
    // console.log(this.form)
    // const result = await changeStatus(this.form.id,this.form.dealResult);
    // this.getList();
    // console.log(result)
  }
  const result = await changeStatus(this.form.id,this.form.dealResult);
  if (result.code === 1200){
    this.getList();
  }
}

export default {
  name: "ServiceTaskDeal",
  props:{
    serviceTask: Object,
    getList: Function
  },
  data(){
    return{
      form:{
        customer:'',
        telephone:'',
        ifsNo:'',
        customerName:'',
        expressCode:'',
        dealResult:'',
      }
    }
  },
  mounted() {
    this.form.id = this.serviceTask.id;
    this.form.customer = this.serviceTask.customer;
    this.form.telephone = this.serviceTask.telephone;
    this.form.ifsNo = this.serviceTask.order.ifsNo;
    this.form.customerName = this.serviceTask.order.customerName;
    this.form.expressCode = this.serviceTask.order.expressCode;
    this.form.dealResult = this.serviceTask.dealResult;
  },
  methods:{
    save,
  }
}
</script>

<style scoped>
  ::-webkit-scrollbar {
    width: 0;
    height: 15px;
    background: #F1F1F1;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #1890FF;
    min-height: 15px;
    min-width: 50px;
    border-radius: 10px;
  }
</style>
